import React from 'react';
export function SectionHeader() {
  return <div className="flex justify-center mb-8" data-id="element-195">
      <div className="bg-lavender text-dark text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full" data-id="element-196">
        APROBÁ EN SERIO · DIGSOL.SHOP
      </div>
    </div>;
}